/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
/**
 * A React functional component that displays the current event details.
 * @returns The JSX element representing the current event details component.
 */
import { saveAs } from "file-saver";
import { debounce } from "lodash";
import moment from "moment";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";

import { buildStaffClubEventQuery } from "../../../helpers/eventClubScope";
import { isEventStatusCompleted } from "../../../helpers/eventSummaryReadiness";
import {
  patchTableBookingAvailability,
  patchTableBookingChannelSoldOut,
  patchTicketSoldOutFlags,
} from "../../../helpers/managerEventUpdate";
import useAuth from "../../../hooks/useAuth";
import useEventSummaryDownload from "../../../hooks/useEventSummaryDownload";
import EventSummaryPendingDevicesModal from "../../../components/eventSummary/EventSummaryPendingDevicesModal";
import { closeClubEvent } from "../../../api/clubApi";
import eventService from "../../../store/features/services/eventServices";
import { unwrapEventRecord } from "../../../helpers/clubCatalog";
import {
  currentEventListResponce,
  deleteEvent,
  eventCancel,
  pastEventListResponce,
  updateEvent,
} from "../../../store/features/event/eventSlice";
import { showToast } from "../../../store/features/toast/toastSlice";
import useWindowDimension from "../../hooks/useWindowDimension";

import Constant from "../../../util/constant";
import CurrentEventDetailComponent from "./currentEventDetailComponent";

const CurrentEventDetailContainer = ({ props }) => {
  /**
   * Retrieves the translation function from the useTranslation hook.
   * Creates a reference to store the page size value.
   * Retrieves the dispatch function from the useDispatch hook.
   * Retrieves the state object from the useLocation hook.
   * Creates a reference to the table container element.
   * Initializes the currentEventItemData variable with the value of currentEvent.
   * Initializes the curruntEventData variable with the data property of currentEventItemData.
   * @returns None
   */
  const navigate = useNavigate();
  const { managedClubId, isAdmin, isClubManager } = useAuth();
  const { t } = useTranslation();
  const { state } = useLocation();
  const eventId = state?.item?._id;
  const pageSizeRef = useRef(4);
  const dispatch = useDispatch();
  const eventsDataRes = useSelector(
    (state) => state?.event?.currentEventListResponce
  );
  const ticketList = useSelector(
    (state) => state?.event?.eventTicketStatusListResponce
  );
  const [eventsData, seteventsData] = useState([]);

  const tableContainerRef = useRef(null);
  const [breadcrumbHeight, setBreadcrumbHeight] = useState("");
  const [deleteLoader, setDeleteLoader] = useState(false);
  const [eventCancelLoader, setEventCancelLoader] = useState(false);
  const dimensions = useWindowDimension();

  /**
   * Manages the state variables related to event modals, status modal, loading state,
   * placeholder state, and cancel event state.
   * @returns {{
   *    showEventDeleteModal: boolean,
   *    setShowEventDeleteModal: function,
   *    showEventCancelModal: boolean,
   *    setShowEventCancelModal: function,
   *    closeEventDeleteModal: function,
   *    closeEventCancelModal: function,
   *    showStatusModal: boolean,
   *    setShowStatusModal: function,
   *    loading: boolean,
   *    setLoading: function,
   *    placeHolder: boolean,
   *    setPlaceHolder: function,
   *    cancelEvent: boolean,
   *    setCancelEvent: function
   * }}
   */
  const [showEventDeleteModal, setShowEventDeleteModal] = useState(false);
  const [showEventCancelModal, setShowEventCancelModal] = useState(false);
  const [showEventCloseModal, setShowEventCloseModal] = useState(false);
  const closeEventDeletModal = () => setShowEventDeleteModal(false);
  const closeEventCancelModal = () => setShowEventCancelModal(false);
  const closeEventCloseModal = () => setShowEventCloseModal(false);
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [placeHolder, setPlaceHolder] = useState(true);
  const [toggleSavingKey, setToggleSavingKey] = useState("");
  const toggleBusyRef = useRef(false);
  const [eventCloseLoader, setEventCloseLoader] = useState(false);
  const [eventClosePatch, setEventClosePatch] = useState(null);
  const [eventDetailsPatch, setEventDetailsPatch] = useState(null);

  const refreshEventDetails = () => {
    if (!eventId) return;
    eventService
      .getEventDetails(eventId)
      .then((res) => {
        const event = unwrapEventRecord(res);
        if (event && typeof event === "object") setEventDetailsPatch(event);
      })
      .catch(() => {});
  };

  useEffect(() => {
    refreshEventDetails();
  }, [eventId]);

  /**
   * useEffect hook that sets the placeholder state to false after a delay of 2000 milliseconds.
   * This is useful for scenarios where you want to show a placeholder content for a certain period
   * of time before rendering the actual content.
   * @returns None
   */

  let eventList = useSelector(
    (reduxState) => reduxState?.event?.currentEventListResponce
  );
  let pastEvents = useSelector(
    (reduxState) => reduxState?.event?.pastEventListResponce
  );
  if (state?.event === "past") {
    eventList = pastEvents;
  }

  const eventListSafe = Array.isArray(eventList) ? eventList : [];
  const foundItem = eventListSafe.find(
    (item) => item?._id?.toString() === state?.item?._id?.toString()
  );
  const eventstatusCancel = foundItem
    ? foundItem?.eventstatus === Constant.GENERALKEYS.CANCEL
      ? true
      : false
    : false;

  useEffect(() => {
    if (!Array.isArray(eventsDataRes) || eventsDataRes.length === 0) {
      seteventsData([]);
      return;
    }
    seteventsData(eventsDataRes.filter((item) => eventId === item?._id));
  }, [eventsDataRes, eventId]);

  useEffect(() => {
    getList();
  }, [managedClubId]);

  const exportToExcel = (fileName) => {
    const jsonData = {};
    const rows = Array.isArray(ticketList) ? ticketList : [];
    rows.forEach((val) => {
      const ticketType = val?.tickettype;
      if (!jsonData[ticketType]) {
        jsonData[ticketType] = [];
      }
                      jsonData[ticketType].push({
                        "Full Name": val?.userid?.fullname,
                        "No. of Tickets": val?.noofticket,
                        "Ticket Price": `₹${val?.ticketprice}`,
                        "Amount Paid": `₹${val?.amount}`,
                        Addons: (val?.addonLines || [])
                          .map((line) => line?.name)
                          .filter(Boolean)
                          .join("; "),
                        Addon_Total: val?.addonTotal ?? "",
                        Delivery: val?.isdelivery ? "Yes" : "No",
                        "Delivery Price":
                          val?.deliveryprice === 0 ? 0 : `₹${val?.deliveryprice}`,
                        "Home Delivery Address": val?.address ? val?.address : "-",
                        "Booking Time": moment(val?.orderstatustimestamp).format(
                          "DD MMM YY, h:mm A"
                        ),
                        "Payment Status": val?.orderstatus,
                      });
    });

    const wb = XLSX.utils.book_new();

    for (const ticketType in jsonData) {
      if (Object.prototype.hasOwnProperty.call(jsonData, ticketType)) {
        const ws = XLSX.utils.json_to_sheet(jsonData[ticketType]);
        XLSX.utils.book_append_sheet(wb, ws, ticketType);
      }
    }

    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const excelData = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    });
    saveAs(excelData, `${fileName}.xlsx`);
  };
  /**
   * Retrieves a list of all genres from the server.
   * @returns None
   */
  const getList = async () => {
    const role = window.localStorage.getItem("role");
    const isClubStaffRole =
      role === Constant.ROLES.CLUB_MANAGER ||
      role === Constant.ROLES.CLUB_EMPLOYEE;
    if (isClubStaffRole) {
      const params = buildStaffClubEventQuery(managedClubId) ?? {};
      dispatch(currentEventListResponce(params)).then((resultAction) => {
        if (currentEventListResponce.fulfilled.match(resultAction)) {
          setPlaceHolder(false);
        } else if (currentEventListResponce.rejected.match(resultAction)) {
          setPlaceHolder(false);
        }
      });
      return;
    }
    dispatch(currentEventListResponce({})).then((resultAction) => {
      if (currentEventListResponce.fulfilled.match(resultAction)) {
        setPlaceHolder(false);
      } else if (currentEventListResponce.rejected.match(resultAction)) {
        setPlaceHolder(false);
      }
    });
  };

  useEffect(() => {
    if (state?.item !== null) {
      setPlaceHolder(false);
    }
  }, []);

  /**
   * An array of objects representing page titles.
   * Each object has a "title" property that contains the translated title string.
   * @type {Array<{title: string}>}
   */
  const pageTitle = [
    {
      title: t("EVENTS"),
      path: "/events-list",
    },
    {
      title: t("LIST"),
      path: "/events-list",
    },
  ];

  const onBackArrow = () => {
    navigate("/events-list");
  };
  /**
   * Opens the event delete modal for the specified item.
   * @param {{Event}} e - The event object.
   * @param {{Item}} item - The item to be deleted.
   * @returns None
   */
  const openEventDeleteModal = (e, item) => {
    setShowEventDeleteModal(true);
  };

  /**
   * Opens the cancel event modal for the specified item.
   * @param {{Event}} e - The event object that triggered the function.
   * @param {{Item}} item - The item for which the cancel event modal should be opened.
   * @returns None
   */
  const openCancelEventModal = (e, item) => {
    setShowEventCancelModal(true);
  };

  const openCloseEventModal = () => {
    setShowEventCloseModal(true);
  };

  /**
   * Loads more items when triggered, with a delay of 2000 milliseconds.
   * @returns None
   */
  const loadMoreItems = () => {
    if (loading) return;
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      pageSizeRef.current += 10;
    }, 2000);
  };

  /**
   * Debounces the handleTableScroll function to prevent it from being called too frequently.
   * When the table container is scrolled, it checks if the scroll position is at the bottom
   * and if there are more items to load. If both conditions are met, it calls the loadMoreItems function.
   * @returns None
   */
  const handleTableScroll = debounce(() => {
    const tableContainer = tableContainerRef.current;
    if (tableContainer) {
      const isAtBottom =
        tableContainer.scrollTop + tableContainer.clientHeight >=
        tableContainer.scrollHeight;
      if (isAtBottom && state?.item?.length > pageSizeRef.current) {
        loadMoreItems();
      }
    }
  }, 200);

  /**
   * Adds an event listener to the table container element to handle scroll events.
   * The event listener is removed when the component is unmounted.
   * @param {{function}} handleTableScroll - The function to handle the table scroll event.
   * @returns None
   */
  useEffect(() => {
    const tableContainer = tableContainerRef.current;
    if (tableContainer) {
      tableContainer.addEventListener("scroll", handleTableScroll);
    }
    return () => {
      if (tableContainer) {
        tableContainer.removeEventListener("scroll", handleTableScroll);
      }
    };
  }, [handleTableScroll]);

  /**
   * Handles the deletion of an event. Displays a success toast message and closes the event delete modal.
   * @returns None
   */
  const onEventDelete = () => {
    setDeleteLoader(true);
    dispatch(deleteEvent(state?.item?._id)).then((resultAction) => {
      if (deleteEvent.fulfilled.match(resultAction)) {
        dispatch(
          showToast({
            show: false,
            message: resultAction?.payload?.message,
            type: "success",
          })
        );
        navigate("/events-list");
        closeEventDeletModal();
        setDeleteLoader(false);
      } else if (deleteEvent.rejected.match(resultAction)) {
        closeEventDeletModal();
        setDeleteLoader(false);
        dispatch(
          showToast({
            show: false,
            message: resultAction?.error?.message,
            type: "error",
          })
        );
      }
    });
  };
  /**
   * useEffect hook that sets the height of the breadcrumb based on the height of the
   * "page-title-box" element.
   * @returns None
   */
  useEffect(() => {
    setBreadcrumbHeight(
      document.getElementsByClassName("page-title-box")[0].offsetHeight
    );
  }, []);
  /**
   * Handles the cancellation of an event.
   * Sets the `cancelEvent` state to `true`.
   * Dispatches a toast message to indicate the successful cancellation of the event.
   * Closes the event cancellation modal after a delay.
   * @returns None
   */
  const onCancelEvent = () => {
    setEventCancelLoader(true);
    dispatch(eventCancel(state?.item?._id)).then((resultAction) => {
      if (eventCancel.fulfilled.match(resultAction)) {
        dispatch(
          showToast({
            show: false,
            message: resultAction?.payload?.res?.message,
            type: "success",
          })
        );
        closeEventCancelModal();
        setEventCancelLoader(false);
      } else if (eventCancel.rejected.match(resultAction)) {
        closeEventCancelModal();
        setEventCancelLoader(false);
        dispatch(
          showToast({
            show: false,
            message: resultAction?.error?.message,
            type: "error",
          })
        );
      }
    });
  };

  const pickCloseEventPayload = (response) => {
    const nested =
      response?.data &&
      typeof response.data === "object" &&
      !Array.isArray(response.data)
        ? response.data
        : response?.res?.data &&
            typeof response.res.data === "object" &&
            !Array.isArray(response.res.data)
          ? response.res.data
          : null;
    const eventstatus =
      nested?.eventstatus ??
      nested?.eventStatus ??
      Constant.GENERALKEYS.COMPELETED;
    const enddatetime =
      nested?.enddatetime ?? nested?.endDateTime ?? new Date().toISOString();
    return { eventstatus, enddatetime };
  };

  const onCloseEvent = async () => {
    const id = state?.item?._id ?? eventId;
    if (!id || eventCloseLoader) return;
    setEventCloseLoader(true);
    try {
      const response = await closeClubEvent(id, { setEndTimeToNow: true });
      setEventClosePatch(pickCloseEventPayload(response));
      const message =
        (typeof response?.message === "string" && response.message.trim()) ||
        (typeof response?.res?.message === "string" &&
          response.res.message.trim()) ||
        t("CLOSE_EVENT");
      dispatch(
        showToast({
          show: false,
          message,
          type: "success",
        })
      );
      closeEventCloseModal();
      const params = buildStaffClubEventQuery(managedClubId) ?? {};
      dispatch(currentEventListResponce(params));
      dispatch(pastEventListResponce(params));
    } catch (error) {
      dispatch(
        showToast({
          show: false,
          message:
            (typeof error === "string" && error) ||
            error?.message ||
            t("CLOSE_EVENT"),
          type: "error",
        })
      );
    } finally {
      setEventCloseLoader(false);
    }
  };

  /**
   * Closes the deactivate modal by setting the showStatusModal state to false.
   * @returns None
   */
  const closeDeactivateModal = () => setShowStatusModal(false);

  const [showLayoutModal, setShowLayoutModal] = useState(false);
  const cancelLayoutModal = () => setShowLayoutModal(false);
  const viewLayoutOpenModal = () => setShowLayoutModal(true);

  const stateEventData = foundItem || state?.item;
  const [tableBookingPricingOverride, setTableBookingPricingOverride] =
    useState(null);
  const [ticketSoldOutOverride, setTicketSoldOutOverride] = useState(null);

  const displayEventData = useMemo(() => {
    if (!stateEventData) return stateEventData;

    let next = stateEventData;
    if (eventDetailsPatch != null) {
      next = { ...next, ...eventDetailsPatch };
    }
    if (ticketSoldOutOverride != null) {
      next = { ...next, tickets: ticketSoldOutOverride };
    }
    if (tableBookingPricingOverride != null) {
      next = { ...next, tableBookingAreaPricing: tableBookingPricingOverride };
    }
    if (eventClosePatch != null) {
      next = { ...next, ...eventClosePatch };
    }
    return next;
  }, [
    stateEventData,
    eventDetailsPatch,
    ticketSoldOutOverride,
    tableBookingPricingOverride,
    eventClosePatch,
  ]);

  useEffect(() => {
    setTableBookingPricingOverride(null);
    setTicketSoldOutOverride(null);
    setEventClosePatch(null);
  }, [stateEventData?._id]);

  const canCloseEvent = Boolean(
    eventId &&
      (isAdmin || isClubManager) &&
      state?.event !== "past" &&
      !eventstatusCancel &&
      displayEventData?.eventstatus !== Constant.GENERALKEYS.CANCEL &&
      !isEventStatusCompleted(displayEventData?.eventstatus)
  );

  const canDownloadEventSummary = Boolean(
    eventId &&
      (isAdmin || isClubManager) &&
      isEventStatusCompleted(displayEventData?.eventstatus)
  );

  const {
    downloading: eventSummaryDownloading,
    checkingReadiness: eventSummaryCheckingReadiness,
    showPendingModal: showEventSummaryPendingModal,
    readinessData: eventSummaryReadinessData,
    forceClosingKey: eventSummaryForceClosingKey,
    closePendingModal: closeEventSummaryPendingModal,
    handleDownload: handleDownloadEventSummary,
    handleCheckScannerStatus: handleCheckEventSummaryScannerStatus,
    handleRetryReadiness: handleRetryEventSummaryReadiness,
    handleForceCloseDevice: handleForceCloseEventSummaryDevice,
  } = useEventSummaryDownload({
    eventId,
    eventTitle: stateEventData?.title ?? "",
    eventStartdatetime: stateEventData?.startdatetime ?? null,
    enabled: canDownloadEventSummary,
    clubId: managedClubId,
  });

  const refetchEventList = () => {
    const params = buildStaffClubEventQuery(managedClubId) ?? {};
    dispatch(currentEventListResponce(params));
  };

  const persistManagerEventUpdate = async (payload, savingKey, options = {}) => {
    if (!payload || toggleBusyRef.current) return;
    toggleBusyRef.current = true;
    setToggleSavingKey(savingKey);
    try {
      const resultAction = await dispatch(updateEvent(payload));
      if (updateEvent.fulfilled.match(resultAction)) {
        refetchEventList();
        dispatch(
          showToast({
            show: false,
            message: resultAction?.payload?.message,
            type: "success",
          })
        );
      } else if (updateEvent.rejected.match(resultAction)) {
        options.onReject?.();
        dispatch(
          showToast({
            show: false,
            message: resultAction?.error?.message,
            type: "error",
          })
        );
      }
    } finally {
      toggleBusyRef.current = false;
      setToggleSavingKey("");
    }
  };

  const handleTicketSoldOutToggle = (ticket, field, checked) => {
    if (!isClubManager || !displayEventData?._id) return;
    const ticketId = ticket?._id ?? ticket?.id;
    if (!ticketId) return;
    const flags =
      field === "offlineSoldOut"
        ? { offlineSoldOut: checked }
        : { soldout: checked };
    const payload = patchTicketSoldOutFlags(displayEventData, ticketId, flags);
    const previousOverride = ticketSoldOutOverride;
    setTicketSoldOutOverride(payload.tickets ?? []);
    persistManagerEventUpdate(payload, `ticket:${ticketId}:${field}`, {
      onReject: () => setTicketSoldOutOverride(previousOverride),
    });
  };

  const handleTableAvailabilityChange = ({
    areaId,
    tableId,
    manualAvailability,
    layoutPrice,
    currency,
  }) => {
    if (!isClubManager || !displayEventData?._id) return;
    const payload = patchTableBookingAvailability(displayEventData, {
      areaId,
      tableId,
      manualAvailability,
      layoutPrice,
      currency,
    });
    const previousOverride = tableBookingPricingOverride;
    setTableBookingPricingOverride(payload.tableBookingAreaPricing ?? []);
    persistManagerEventUpdate(
      payload,
      `table:${areaId}:${tableId || "zone"}:${manualAvailability}`,
      {
        onReject: () => setTableBookingPricingOverride(previousOverride),
      }
    );
  };

  const handleTableChannelSoldOutChange = ({
    areaId,
    tableId,
    onlineSoldOut,
    offlineSoldOut,
    layoutPrice,
    currency,
    nestedTables,
  }) => {
    if (!isClubManager || !displayEventData?._id) return;
    const payload = patchTableBookingChannelSoldOut(displayEventData, {
      areaId,
      tableId,
      onlineSoldOut,
      offlineSoldOut,
      layoutPrice,
      currency,
      nestedTables,
    });
    const previousOverride = tableBookingPricingOverride;
    setTableBookingPricingOverride(payload.tableBookingAreaPricing ?? []);
    persistManagerEventUpdate(
      payload,
      `table:${areaId}:${tableId || "zone"}:channelSoldOut`,
      {
        onReject: () => setTableBookingPricingOverride(previousOverride),
      }
    );
  };

  return (
    <>
    <CurrentEventDetailComponent
      tableContainerRef={tableContainerRef}
      noDataFound={"noDataFound"}
      noDataTitle={t("NO_REPORT_FOUND")}
      noDataDesc={t(
        "YOUR_SEARCH_DID_NOT_MATCH_ANY_REPORTS_PLEASE_TRY_SEARCHING_AGAIN"
      )}
      showEventDeleteModal={showEventDeleteModal}
      showEventCancelModal={showEventCancelModal}
      showEventCloseModal={showEventCloseModal}
      openEventDeleteModal={(e, item) => {
        openEventDeleteModal(e, item);
      }}
      closeEventDeletModal={closeEventDeletModal}
      onEventDelete={onEventDelete}
      onCancelEvent={onCancelEvent}
      onCloseEvent={onCloseEvent}
      state={state}
      showStatusModal={showStatusModal}
      closeDeactiveModal={closeDeactivateModal}
      placeHolderShimer={placeHolder}
      openCancelEventModal={openCancelEventModal}
      openCloseEventModal={openCloseEventModal}
      pageTitle={pageTitle}
      onBackArrow={onBackArrow}
      breadcrumbHeight={breadcrumbHeight}
      dimensions={dimensions}
      deleteLoader={deleteLoader}
      eventstatusCancel={eventstatusCancel}
      eventCancelLoader={eventCancelLoader}
      eventCloseLoader={eventCloseLoader}
      canCloseEvent={canCloseEvent}
      foundItem={displayEventData}
      closeEventCancelModal={closeEventCancelModal}
      closeEventCloseModal={closeEventCloseModal}
      eventsDataRes={eventsData}
      exportToExcel={exportToExcel}
      viewLayoutOpenModal={viewLayoutOpenModal}
      showLayoutModal={showLayoutModal}
      cancelLayoutModal={cancelLayoutModal}
      canDownloadEventSummary={canDownloadEventSummary}
      eventSummaryDownloading={eventSummaryDownloading}
      eventSummaryCheckingReadiness={eventSummaryCheckingReadiness}
      onDownloadEventSummary={handleDownloadEventSummary}
      onCheckEventSummaryScannerStatus={handleCheckEventSummaryScannerStatus}
      eventsReadOnly={isClubManager}
      clubId={
        managedClubId ||
        displayEventData?.clubid ||
        displayEventData?.clubId ||
        null
      }
      isClubManager={isClubManager}
      isAdmin={isAdmin}
      onCatalogAttachSaved={refreshEventDetails}
      canManageSoldOutToggles={isClubManager}
      onTicketSoldOutToggle={handleTicketSoldOutToggle}
      onTableAvailabilityChange={handleTableAvailabilityChange}
      onTableChannelSoldOutChange={handleTableChannelSoldOutChange}
      toggleSavingKey={toggleSavingKey}
    />
      <EventSummaryPendingDevicesModal
        show={showEventSummaryPendingModal}
        onHide={closeEventSummaryPendingModal}
        readiness={eventSummaryReadinessData}
        onRetry={handleRetryEventSummaryReadiness}
        onForceClose={handleForceCloseEventSummaryDevice}
        retrying={eventSummaryCheckingReadiness || eventSummaryDownloading}
        forceClosingKey={eventSummaryForceClosingKey}
      />
    </>
  );
};
export default CurrentEventDetailContainer;
